import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTranslation } from "@/hooks/useTranslation";

export const SetupTrialEndedIntroductionPage = () => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.trialEnded.introduction.title")}
      </h1>
      <p
        className="text-md"
        dangerouslySetInnerHTML={{
          __html: t("setup.trialEnded.introduction.description"),
        }}
      />
      <Button onClick={nextStep}>
        {t("setup.trialEnded.introduction.button")}
      </Button>
    </div>
  );
};
